var map = {
	"./aws.svg": "f963",
	"./chrome.svg": "0747",
	"./discord.svg": "7d6d",
	"./edge.svg": "0a9d",
	"./firefox.svg": "75d0",
	"./gigbridge.svg": "fd03",
	"./gmail.svg": "dfd3",
	"./grid.svg": "afb3",
	"./logo-wide.svg": "e64e",
	"./logo.svg": "e347",
	"./meet.svg": "1ca5",
	"./safari.svg": "c5a9",
	"./slack.svg": "7935",
	"./telegram.svg": "0c86",
	"./twitter.svg": "1538"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c6e";